import { render, staticRenderFns } from "./CardGroup.vue?vue&type=template&id=0da345ae&scoped=true&"
import script from "./CardGroup.vue?vue&type=script&lang=js&"
export * from "./CardGroup.vue?vue&type=script&lang=js&"
import style0 from "./CardGroup.vue?vue&type=style&index=0&id=0da345ae&lang=scss&scoped=true&"
import style1 from "./CardGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da345ae",
  null
  
)

export default component.exports